import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  width: 210px;
  min-height: 35px;
`;

export const DropdownHeader = styled.div`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${(prop) => (prop.color ? '#07082c' : '#646378')};
  min-height: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* Centra verticalmente los elementos */
`;

export const ArrowIcon = styled.div`
  font-size: 18px;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  padding: 8px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  list-style: none;
  z-index: 1;
  width: 190px;
  max-height: 140px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

export const DropdownItem = styled.li`
  padding: 8px;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #07082c;
  &:hover {
    background-color: #f0f0f0;
  }
`;